/**
 * 大事记列表
 */
import request from '../request'
const emailApi = {}

// 获取email 列表
emailApi.getEmailList = param => {
  return request({
    url: '/function/email/list',
    method: 'GET',
    params: param
  })
}

// 新建
emailApi.addEmail = params => {
  return request({
    url: '/function/email',
    method: 'POST',
    data: params
  })
}

// 新建
emailApi.CreateEmail = param => {
  return request({
    url: '/function/index/createIndex',
    method: 'GET',
    params: param
  })
}

// 修改
emailApi.updateEmail = params => {
  return request({
    url: '/function/email',
    method: 'PUT',
    data: params
  })
}

// 根据ID 查询详情
emailApi.queryDetailById = param => {
  return request({
    url: '/function/email',
    method: 'GET',
    params: param
  })
}

// 删除一条
emailApi.deleteEmail = params => {
  return request({
    url: '/function/email/remove',
    method: 'POST',
    data: params
  })
}

export default emailApi
